/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Frame_TitleInputs */

const en_fc_home_features_frame_title = /** @type {(inputs: Fc_Home_Features_Frame_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frame-exact time`)
};

/**
* | output |
* | --- |
* | "Frame-exact time" |
*
* @param {Fc_Home_Features_Frame_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_frame_title = /** @type {((inputs?: Fc_Home_Features_Frame_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Frame_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_frame_title(inputs)
});
export { fc_home_features_frame_title as "fc.home.features.frame.title" }